<script setup lang="ts">
import type { CellGroupProps } from '@components/NovaHeaderCellGroup/NovaHeaderCellGroup.types'
import { CellGroupTheme } from '@components/NovaHeaderCellGroup/NovaHeaderCellGroup.types'

withDefaults(defineProps<CellGroupProps>(), {
  groupName: '',
  theme: CellGroupTheme.DEFAULT,
})
</script>

<template>
  <div :class="['cell-group', `theme-${theme}`]">
    <h4 v-if="groupName" class="group-name">{{ groupName }}</h4>

    <div class="cells">
      <slot name="cells" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cell-group {
  display: flex;
  flex-direction: column;
  gap: 4px;

  &.theme {
    &-white-box {
      padding: 8px 16px;
      background-color: $color-white;
      border-radius: 8px;
    }
  }

  .group-name {
    @include text-style($text-body-14-bold);
    color: $color-text-2;
    padding: 4px 0;
  }

  .cells {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
}
</style>
